// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { borderRadius, spacing } from '../../tokens/spacing';
import { dialogColors } from './dialogColors';
export var Dialog = function(mode) {
    var c = dialogColors(mode);
    var override = {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: rem(borderRadius.default),
                    padding: rem(spacing[8]),
                    gap: rem(spacing[8]),
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: c.default.background,
                    backgroundImage: 'none',
                    color: c.default.text,
                    border: "1px solid ".concat(c.default.border),
                    boxShadow: '0px 18px 36px rgba(0, 0, 0, 0.2)'
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: rem(0),
                    color: c.default.title
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: rem(0)
                }
            }
        },
        MuiDialogActions: {
            defaultProps: {
                disableSpacing: true
            },
            styleOverrides: {
                root: {
                    padding: rem(0),
                    gap: rem(spacing[3])
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Dialog.js.map